import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Home = () => {

  //pop-ups functions
  function handleContact() {
  return alert(`${"Contact us on 📞 : 0796225100"} \n\n ${"email 📧: kabururm@gmail.com"}`);
  }
  
  function handlePopUp() {
    return alert("not available at the moment");
  }

  return (
    <div className="home">
       <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" />
<header></header>
<section className="section-one">
  <div className="bar">
    <h2>Get Your Dream Super Dog With Us</h2>
    <div className="icons-container">
      <div className="icon-items">
        <img src="" alt="" />
        <p>Free Delivery</p>
      </div >
      <div className="icon-items">
        <img src="" alt="" />
        <p>Free Medical Check-up</p>
      </div>
      <div className="icon-items">

        <img src="" alt="" />
        <p>Dog Grooming</p>
       </div>
      <div className="icon-items" >
        <img src="" alt="" />
        <p>Friendly price</p>
     </div>
</div>
  </div>
        
  <script type="text/javascript" src="http://wowslider.com/images/effects/rotate.js"></script>  
<script type="text/javascript" src="http://wowslider.com/images/demo/jquery.js"></script>
      
<link rel="stylesheet" type="text/css" href="http://wowslider.com/sliders/demo-57/engine1/style.css" />

<div id="wowslider-container1">
<div class="ws_images">
<ul>
<li id="wowslider"><img style={{width: '45%', height: '50%'}} src="http://www.dogsforsale.co.in/wp-content/uploads/2018/06/labrador-123.jpg" alt="chiwawa" title="Labrador" id="wows1_0"/><button>Labrador</button> </li>
<li id="wowslider"><img style={{width: '70%', height: '100%'}} src="https://media.istockphoto.com/photos/portrait-of-three-dogs-closeup-picture-id607270080?k=20&m=607270080&s=612x612&w=0&h=UiWL_-Rhz5BNXjq7I1hicgP1OZ8QtvvHZhGPq-hBH1E=" alt="german shepherd" title=" German shepherd" id="wows1_1"/><button>German shepherd</button> </li>
<li id="wowslider"><img style={{width: '45%', height: '50%'}}  src="http://www.dogsforsale.co.in/wp-content/uploads/2018/06/Golden-Retriever-600x600.jpg" alt="Mountains: slideshow html images" title="Golden Retriever" id="wows1_2"/> <button>Golden retriver</button> </li>
<li id="wowslider"><img style={{width: '45%', height: '50%'}}  src="http://www.dogsforsale.co.in/wp-content/uploads/2018/06/Rottweiler-600x600.jpg" alt="Yosemite National Park: slideshow html javascript" title="Rottweiler" id="wows1_3"/> <button>Rottweiler</button> </li>
</ul>
</div>
</div>
        <hr />
</section> 

<section id="reviews">
        <p className="review-head">Our App Connects You To Top Dog Sellers & Dog Service Providers</p>
        <div className="review-container">
          <div>
            <img style={{ width: "40%", height: "50%",borderRadius: "100%" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjgzOoeWAe9w4YTYMye3LNwVWU2QVptuu07w&usqp=CAU" alt="profile" />
            <p>Client: Jane White</p>
            <img  style={{ width: "20%", height: "7%"}} src="https://static.vecteezy.com/system/resources/thumbnails/007/498/655/small/yellow-five-stars-quality-rating-icons-5-stars-icon-five-star-sign-rating-symbol-illustration-vector.jpg" alt="" />
            <p>post/review</p>
            <p>I bought my chiwawa here <br /> and it's now 3 years old.Thank you </p>
          </div>
          <div>
            <img style={{ width: "40%", height: "50%",borderRadius: "100%" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQall9DVYi-j82ZvcO95EiAEAhYuFeQim39tA&usqp=CAU" alt="profile" />
            <p>Seller: Mike Kaburu</p>
            <img style={{ width: "20%", height: "7%"}} src="https://static.vecteezy.com/system/resources/thumbnails/007/498/655/small/yellow-five-stars-quality-rating-icons-5-stars-icon-five-star-sign-rating-symbol-illustration-vector.jpg" alt="" />
            <p>post/review</p>
            <p>German Shepherd <br /> 6 months old @ksh.30,000 </p>
          </div>
          <div>
            <img style={{ width: "40%", height: "50%",borderRadius: "100%" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBlFTdul-opDBqmtFZhXAPHu7qkheNMtKiuw&usqp=CAU" alt="profile" />
            <p>Dog day care</p>
            <img style={{ width: "20%", height: "7%"}} src="https://static.vecteezy.com/system/resources/thumbnails/007/498/655/small/yellow-five-stars-quality-rating-icons-5-stars-icon-five-star-sign-rating-symbol-illustration-vector.jpg" alt="" />
            <p>post/review</p>
            <p>6 hours dog day care <br /> @ksh. 600 </p>
          </div>
          <div>
            <img style={{ width: "40%", height: "50%",borderRadius: "100%" }} src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTjIN8RdzndtF1P2F5ewNZkDN156gMxpbpVqQ&usqp=CAU" alt="profile" />
            <p>Client: Mercy Muthoni</p>
            <img style={{ width: "20%", height: "7%"}} src="https://static.vecteezy.com/system/resources/thumbnails/007/498/655/small/yellow-five-stars-quality-rating-icons-5-stars-icon-five-star-sign-rating-symbol-illustration-vector.jpg" alt="" />
            <p>post/review</p>
            <p>Day care dog services <br /> offered here are the best </p>
          </div>
        </div>
        <div className="review-bottom">
          <h2>Find Best Suitable Dog For Your Home</h2>
        <button onClick={handlePopUp} id="leave-comment"> <FontAwesomeIcon icon={faEnvelope} />  Leave a review</button>
        </div>
       
      </section>

      <section id="health-container" >
<div className="health-section" >
  <div className="left-section">
  <h2>Free Health Check</h2>
    <p>At Dogs Market, we take our responsibilities regarding the health and well- <br /> being of your puppy very seriously. <br />
All of our puppies visit a qualified, registered veterinarian prior to their delivery <br /> where they are health-checked, tested, given their first vaccination, de-wormed, <br /> treated to prevent parasites.  <br />
No other puppy provider/breeder in Kenya goes to the lengths we do to ensure <br /> that you receive your puppy in perfect health.</p>
 <Link to="services"> <button onClick={handleContact} id="contact-us"> ➲ Contact Us</button></Link> 

  </div>
  <div className="right-section">
  <img src="http://www.dogsforsale.co.in/wp-content/uploads/2018/06/209707.jpg" alt="vetrinary-img" />
  </div>
</div>
</section>

<section>
  <footer id="footer">
          <p>📧 infor@dogsmarket.co.ke</p>
          <p>Designed by : Michael Kaburu</p>
          <p>contact : +254796225100</p>
</footer>
</section>
    
</div>
	
		
	 );
}
 
export default Home;
